import { Link } from '@mna/react'
import React, { useState } from 'react';
import low from 'assets/img/low.png'
import high from 'assets/img/high.png'
import medium from 'assets/img/medium.png'
import LoadingScreen from 'features/LoadingScreen'
import { Trans } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faVirus } from '@fortawesome/free-solid-svg-icons'



export default ({ state, actions, history, previousStepName, nextStepName, careOptionName = 'Care Service' }) => {
  localStorage.getItem("covidurl", "null")
  if (localStorage.getItem("isCovidPageLoaded") === "false") {
    localStorage.setItem("isCovidPageLoaded", "true");
   // window.addEventListener('load', actions.getGuidlines())
  }
  const coviddata = localStorage.getItem("covidurl")



  return (

    <div className="content-width mt-3 row">
      <LoadingScreen isLoading={state.isLoading}>
        <div className="col-12">
          <div className="row covid-info-area">
            <div className="col-4"></div>
            <div className="col-4">
              {state.triageRequest.covidstatus == "high" ? <img src={high} className="covid-info-icon" /> : state.triageRequest.covidstatus == "medium" ? <img src={medium} className="covid-info-icon" /> : <img src={low} className="covid-info-icon" />}
            </div>
            <div className="col-4"></div>
          </div>
        </div>
        <div className="col-12">
          <div className="row covid-info-area">
            <div className="col-12">
              <h1 className="text-center standby-page-header-title covid-info-heading"><Trans i18nKey="findcareoption.Covid.Covid_check">COVID CHECK</Trans></h1>
            </div>
          </div>
        </div>
        <div className="col-12">
          <p className="covid-info-message w-form-label-justify">
            <strong>{state.triageRequest.covidmsg}</strong>
          </p>
          <p className="covid-info-message w-form-label-justify"><Trans i18nKey="findcareoption.Covid.Confirm_text">
            Would you like to view local COVID guidelines or continue to your care recommendations?
            </Trans>
          </p>
        </div>

        <div class="video-prompt row">
          <div class="col-6 text-right video-prompt-item">
           
            <button type="button" class="button video-prompt video-prompt-no" onClick={e => {
             {coviddata!="null"?window.open(coviddata, "_blank"):""}
            }}>
              <div class="icon icon-size-3"><FontAwesomeIcon style={{ color: "navy", fontSize: "25px" }} icon={faVirus} /></div>
              <div ><Trans i18nKey="findcareoption.Covid.Guidelines_text">Guidelines</Trans></div>
            </button>

          </div>

          <div class="col-6 text-left video-prompt-item">
            <button type="button" class="button video-prompt video-prompt-no" onClick={e => {
              state.triageRequest.activeMenu = 'care-options'
              history.push('/find-care-options/care-options')
            }}>
              <div class="icon icon-size-3"><FontAwesomeIcon style={{ color: "green", fontSize: "25px" }} icon={faCheck} /></div>
              <div ><Trans i18nKey="findcareoption.Covid.Continue_text">Continue</Trans></div>
            </button>
          </div>
        </div>




      </LoadingScreen>
    </div>

  )
}





